import { render, staticRenderFns } from "./articleview-index.vue?vue&type=template&id=e3527096&scoped=true&"
import script from "./articleview-index.vue?vue&type=script&lang=js&"
export * from "./articleview-index.vue?vue&type=script&lang=js&"
import style0 from "./articleview-index.vue?vue&type=style&index=0&id=e3527096&prod&lang=css&"
import style1 from "./articleview-index.vue?vue&type=style&index=1&id=e3527096&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3527096",
  null
  
)

export default component.exports